import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import { parseLabeledLines } from '../../lib/parseLabeledLines';
import type { BlockRenderProps } from '../../types';

export function SocialFeedGrid({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const handle = pickBlockField(block.content, 'handle', locale);
  const postsRaw = pickBlockField(block.content, 'posts', locale);
  const posts = parseLabeledLines(postsRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-social-feed', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="social"
    >
      <div className="ws-social-feed__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-social-feed__title"
        >
          {sectionTitle}
        </EditableContent>
        {handle || editable ? (
          <EditableContent
            fieldKey="handle"
            editable={editable}
            activeEditTarget={target}
            className="ws-social-feed__handle"
          >
            {handle}
          </EditableContent>
        ) : null}
        {editable ? (
          <EditableContent
            fieldKey="posts"
            editable={editable}
            activeEditTarget={target}
            className="ws-social-feed__editor"
          >
            {postsRaw}
          </EditableContent>
        ) : (
          <ul className="ws-social-feed__grid">
            {posts.map((post, index) => (
              <li key={`${post.label}-${index}`} className="ws-social-feed__card">
                <p className="ws-social-feed__caption">{post.label}</p>
                {post.meta ? <p className="ws-social-feed__meta">{post.meta}</p> : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
